// extracted by mini-css-extract-plugin
var _1 = "ProductUpdateModal-module__animateUploadProgressBarWidth--eR6fG";
var _2 = "ProductUpdateModal-module__animatedBackground--nfliy";
var _3 = "ProductUpdateModal-module__headerBar--K47ho";
var _4 = "ProductUpdateModal-module__meta--Kie0r";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "headerBar", _4 as "meta" }
